
angular.module('bmsApp.settings').controller('RiskAssessmentQuestionModalFormCtrl', [
	'$scope',
	'$q',
	'$timeout',
	'$filter',
	'$modalInstance',
	'$ngBootbox',
	'RiskAssessmentQuestionSvc',
	'RiskAssessmentQuestionTypeSvc',
	'license',
	'question', function (
		$scope,
		$q,
		$timeout,
		$filter,
		$modalInstance,
		$ngBootbox,
		RiskAssessmentQuestionSvc,
		RiskAssessmentQuestionTypeSvc,
		license,
		question) {

		$scope.loading = true;
		$scope.processing = false;
		$scope.options = {};

		$scope.question = angular.extend($scope.question = {
			license: license
		}, question);

		var promises = {
			riskAssessmentQuestionTypeOptions: RiskAssessmentQuestionTypeSvc.options(),
		};

		$q.all(promises).then(function (responses) {
			$scope.options.questionTypes = responses.riskAssessmentQuestionTypeOptions.data.options;
			$scope.loading = false;
		});


		$scope.formvalidatorconfig = {
			submitHandler: function () {
				$scope.submit($scope.question);
			},
			errorPlacement: function (error) {
				error.appendTo('#risk-assessment-errors');
			},
			errorContainer: '#risk-assessment-errors'
		};

		$scope.submit = function (question) {
			$scope.processing = true;
			var modalResult = {};
			var savePromise = RiskAssessmentQuestionSvc.save(question);
			savePromise
				.then(function (response) {
					modalResult.success = response.data.success;
					modalResult.action = question.id ? 'update' : 'create';
					modalResult.question = question;
					$modalInstance.close(modalResult);
				}, function (error) {
					modalResult.error = error;
					// $modalInstance.close(modalResult);
				})
				.finally(function() {
					$scope.processing = false;
				});
		};

		$scope.cancel = function () {
			$ngBootbox.confirm('Are you sure you want to do this?')
				.then(function () {
					$modalInstance.dismiss('cancel');
				});
		};

	}]);
